import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./MarketplaceTransactionUIHelpers";

const MarketplaceTransactionUIContext = createContext();

export function useMarketplaceTransactionUIContext() {
  return useContext(MarketplaceTransactionUIContext);
}

export const MarketplaceTransactionUIConsumer =
  MarketplaceTransactionUIContext.Consumer;

export function MarketplaceTransactionUIProvider({
  marketplaceTransactionUIEvents,
  children,
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initMarketplaceTransaction = {
    id: undefined,
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    gender: "Female",
    status: 0,
    dateOfBbirth: "",
    ipAddress: "",
    type: 1,
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    initMarketplaceTransaction,
    newMarketplaceTransactionButtonClick:
      marketplaceTransactionUIEvents.newMarketplaceTransactionButtonClick,
    openEditMarketplaceTransaction:
      marketplaceTransactionUIEvents.openEditMarketplaceTransaction,
  };

  return (
    <MarketplaceTransactionUIContext.Provider value={value}>
      {children}
    </MarketplaceTransactionUIContext.Provider>
  );
}
